"use client";
import React, { useEffect, useState } from 'react'
import dash from "./dash.module.css";
import watch from "../watchnow/watch.module.css"
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useAuthStore } from '../store/authstore';
import { normalizeGoogleAvatarUrl } from '../utils/avatar';
/* eslint-disable @next/next/no-img-element */
// 
export default function Dashboard() {
    const router = useRouter();
    const user = useAuthStore((state) => state.user);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => setIsClient(true), []);
    useEffect(() => {
        // eslint-disable-next-line
        isClient && setTimeout(() => !user && router.push('/'), 100);
    }, [user, isClient, router]);

    return (
        <div>
            <div className={watch.watchNow}>
                <h2>Dashboard</h2>
            </div>

            <div className={dash.dashboard}>
                <div className="container">
                    <div className={dash.DashboardContent}>
                        <div className={dash.dashboardIcon}>

                            <img
                                style={{ display: user?.user_image ? 'block' : 'none', height: '100%' }}
                                src={normalizeGoogleAvatarUrl(user?.user_image) || '#'}
                                alt="img"
                                loading="lazy"
                                referrerPolicy="no-referrer"
                                crossOrigin="anonymous"
                                onError={(e) => {
                                    const el = e.currentTarget as HTMLImageElement;
                                    // prevent infinite loop
                                    if (el.dataset.fallbackApplied) return;
                                    el.dataset.fallbackApplied = '1';
                                    el.src = '/userIcon.png';
                                }}
                            />
                            <svg style={{ display: user?.user_image ? 'none' : 'block' , height: '100%' }} xmlns="http://www.w3.org/2000/svg" width="103" height="104" viewBox="0 0 103 104" fill="none">
                                <circle cx="51.7056" cy="52.1047" r="51.1829" fill="#E21220" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M51.7049 21.9678C44.7708 21.9678 39.1497 27.5889 39.1497 34.523C39.1497 41.4571 44.7708 47.0782 51.7049 47.0782C58.6389 47.0782 64.2601 41.4571 64.2601 34.523C64.2601 27.5889 58.6389 21.9678 51.7049 21.9678ZM44.1717 34.523C44.1717 30.3626 47.5445 26.9899 51.7049 26.9899C55.8654 26.9899 59.238 30.3626 59.238 34.523C59.238 38.6834 55.8654 42.0561 51.7049 42.0561C47.5445 42.0561 44.1717 38.6834 44.1717 34.523Z" fill="white" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M50.5888 52.1016C35.9502 52.1016 24.0833 63.9685 24.0833 78.6071C24.0833 80.6102 25.7071 82.2341 27.7103 82.2341H75.6993C77.7024 82.2341 79.3262 80.6102 79.3262 78.6071C79.3262 63.9685 67.4593 52.1016 52.8207 52.1016H50.5888ZM52.8207 57.1237C64.217 57.1237 73.5408 65.9972 74.2597 77.212H29.1499C29.8687 65.9972 39.1924 57.1237 50.5888 57.1237H52.8207Z" fill="white" />
                            </svg>

                        </div>
                        <h2>{user && user?.user_name || 'Guest'}</h2>
                        <p>{user && user?.user_email || 'Guest'}</p>
                        <div className={dash.editprofilebtn}>
                            <Link href="/editprofile" className='commonBtn'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                    <path d="M14.4079 3.39075C14.2535 2.72153 13.8608 2.04771 13.3024 1.48933C12.744 0.930954 12.0685 0.538207 11.401 0.383869C10.5958 0.198161 9.85343 0.37383 9.35947 0.866542L1.62456 8.60145C1.49901 8.72685 1.41418 8.88718 1.38114 9.06153L0.609445 13.1521C0.58546 13.2797 0.589893 13.4109 0.622428 13.5365C0.654964 13.6621 0.714801 13.779 0.797678 13.8789C0.880555 13.9787 0.984432 14.0591 1.10191 14.1142C1.21939 14.1693 1.34757 14.1979 1.47734 14.1978C1.53222 14.1978 1.58698 14.1926 1.64088 14.1823L5.72938 13.4106C5.90376 13.3777 6.06413 13.2928 6.18947 13.1672L13.9252 5.43228C14.4179 4.93957 14.5936 4.19548 14.4079 3.39075ZM5.13378 11.7254L2.58531 12.2064L3.06631 9.65797L8.46564 4.25864L10.5331 6.3261L5.13378 11.7254ZM12.6763 4.18335L11.7825 5.07718L9.71457 3.00929L10.6084 2.11589C10.6356 2.0887 10.7673 2.05064 11.0028 2.10501C11.3479 2.1849 11.7306 2.41578 12.0535 2.73826C12.7206 3.40664 12.7783 4.08088 12.6763 4.18335Z" fill="white" />
                                </svg>
                                <span>Edit Profile</span>
                            </Link>
                        </div>
                        <Link href="/deleteacc" className={dash.link}>Delete Account</Link>
                    </div>
                </div>
            </div>
        </div>

    )
}
